/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Smart Home API
 * A smart home management system providing REST APIs for device integrations and automation
 * OpenAPI spec version: 1.0
 */

export type ShellyCreateDeviceRequestDeviceType =
  (typeof ShellyCreateDeviceRequestDeviceType)[keyof typeof ShellyCreateDeviceRequestDeviceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShellyCreateDeviceRequestDeviceType = {
  switch: 'switch',
  light: 'light',
  window_covering: 'window_covering',
  fan: 'fan',
  speaker: 'speaker',
  tv: 'tv',
} as const;
